export const queryJsomCsom = (shpAccess, query) =>
    shpAccess.querySpListAsync(query);